import Service from '@/services/modules/plans.service';

const add = async({ commit }, _object) => {
    console.log(_object);
    const response = Service.add(_object.administrator_id, _object.form);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }, _administratorId) => {
    const response = Service.get(_administratorId);

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async({ commit }, _object) => {
    const response = Service.edit(_object.administrator_id, _object.id, _object);

    return response;
};

const get = async ({ commit }, _object) => {
    const response = Service.get(_object.administrator_id, _object.id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _object) => {
    const response = Service.rem(_object.administrator_id, _object.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    rem
};